import React from 'react';
import PropTypes from 'prop-types';
import { gql, useQuery } from '@apollo/client';
import { useEcommerceContext } from '@blaze-cms/ecommerce-context';
import ProductPrice from './ProductPrice';

const GET_PRODUCT_FROM_PRICE_QUERY = gql`
  query ecommerceGetProductFromPrice($id: String!, $currency: String, $entityIdentifier: String) {
    productFromPrice: ecommerceGetProductFromPrice(
      id: $id
      currency: $currency
      entityIdentifier: $entityIdentifier
    ) {
      fromPrice
      product {
        url
        productType
        variants {
          variantId
          name
          isAvailable
          attributes
          persistedData
        }
      }
    }
  }
`;

const addPublishedEntityPrefix = entityIdentifier => `published_${entityIdentifier}`;

const ProductPriceContainer = ({
  parent,
  prefix,
  buttonText,
  showButtonTextforOffer,
  VariantComponent
}) => {
  const { itemEntity: parentEntity, itemId: parentId } = parent;
  const { currency } = useEcommerceContext();

  const {
    data: { productFromPrice } = {},
    error,
    loading
  } = useQuery(GET_PRODUCT_FROM_PRICE_QUERY, {
    variables: {
      id: parentId,
      entityIdentifier: addPublishedEntityPrefix(parentEntity),
      currency
    },
    skip: !parentId || !parentEntity
  });

  if (loading) return null;
  if (error) return null;
  if (!productFromPrice?.fromPrice) return null;

  const { fromPrice, product } = productFromPrice;
  const { url, variants = [] } = product;
  const variant = variants[0];
  const Component = VariantComponent || ProductPrice;
  return (
    <Component
      prefix={prefix}
      buttonText={buttonText}
      showButtonTextforOffer={showButtonTextforOffer}
      price={fromPrice}
      url={url}
      parentId={parentId}
      selectedVariant={variant}
    />
  );
};

ProductPriceContainer.propTypes = {
  parent: PropTypes.shape({
    itemId: PropTypes.string,
    itemEntity: PropTypes.string
  }).isRequired,
  prefix: PropTypes.string,
  buttonText: PropTypes.string,
  showButtonTextforOffer: PropTypes.bool,
  VariantComponent: PropTypes.elementType
};

ProductPriceContainer.defaultProps = {
  prefix: '',
  buttonText: '',
  showButtonTextforOffer: false,
  VariantComponent: null
};

export default ProductPriceContainer;
